import { Text } from '@sparemin/blockhead';
import * as S from './styles';

export interface IntroViewCardProps {
  title: string;
  image: React.ReactNode;
}

const IntroViewCard: React.FC<IntroViewCardProps> = ({ title, image }) => (
  <S.IntroViewCard>
    {image}

    <Text variant="p" align="center">
      {title}
    </Text>
  </S.IntroViewCard>
);

export default IntroViewCard;
